import { jsx as _jsx } from "react/jsx-runtime";
export const FileClose = ({ size = 12, color = 'var(--moveo-ui-background-01)', }) => {
    return (_jsx("svg", { viewBox: "0 0 24 24", width: size, height: size, className: "stroke", stroke: color, strokeWidth: "2", strokeLinecap: "round", fill: "none", shapeRendering: "geometricPrecision", children: _jsx("path", { d: "M3.96 4l7.96 8-7.96 8M20.04 4l-7.96 8 7.96 8" }) }));
};
